import { useHumanReadableErrorMessage } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_hooks/useHumanReadableErrorMessage";
import { Core } from "@faire/design-tokens";
import { WebApiError } from "@faire/web-api--source/WebApiError";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";

interface IProps {
  error: WebApiError | null | undefined;
}

export const WebApiErrorMessage: React.FC<IProps> = ({ error }) => {
  const { humanReadableErrorMessage } = useHumanReadableErrorMessage();

  if (!error) {
    return null;
  }

  return (
    <Typography color={Core.text.critical}>
      {humanReadableErrorMessage(error)}
    </Typography>
  );
};
